var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{staticClass:"video-upload",attrs:{"action":_vm.action,"accept":"video/mp4","show-file-list":false,"on-success":_vm.handleSuccess,"before-upload":_vm.beforeUpload,"on-progress":_vm.onProgress,"on-error":_vm.onError,"headers":_vm.headers,"name":"vedio.mp4"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-776f110c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadVideo/index.vue
// module id = null
// module chunks = 